define("@ember/runloop/type-tests.ts/later.test", ["@ember/runloop", "expect-type"], function (_runloop, _expectType) {
  "use strict";

  class Foo {
    test(_foo, _bar, _baz) {
      return 1;
    }
  }
  var foo = new Foo(); // With only function

  (0, _expectType.expectTypeOf)((0, _runloop.later)((_foo, _bar, _baz) => {
    return 1;
  }, 1, true, undefined, 1)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.later)((_foo, _bar, _baz) => {
    return 1;
  }, 1, true, 'string', 1)).toEqualTypeOf();
  (0, _runloop.later)(_foo => {
    return 1; // @ts-expect-error invalid argument
  }, 'string'); // With target and function

  (0, _expectType.expectTypeOf)((0, _runloop.later)(foo, function (_foo, _bar, _baz) {
    (0, _expectType.expectTypeOf)(this).toEqualTypeOf();
    return 1;
  }, 1, true, undefined, 1)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.later)(foo, function (_foo, _bar, _baz) {
    return 1;
  }, 1, true, 'string', 1)).toEqualTypeOf(); // @ts-expect-error invalid args

  (0, _runloop.later)(foo, function (_foo, _bar, _baz) {
    return 1;
  }, 1, 'string', true, 1); // With function string reference

  (0, _expectType.expectTypeOf)((0, _runloop.later)(foo, 'test', 1, true, 'string', 1)).toEqualTypeOf();
  (0, _expectType.expectTypeOf)((0, _runloop.later)(foo, 'test', 1, true, undefined, 1)).toEqualTypeOf(); // @ts-expect-error Invalid args

  (0, _runloop.later)(foo, 'test', 'string');
});